[
    {
        "category": "💛 Thank You",
        "folder": "b",
        "count": 12
    },
    {
        "category": "❤️ I Love You",
        "folder": "m",
        "count": 1
    },
    {
        "category": "🎂 Happy Birthday",
        "folder": "g",
        "count": 12
    },
    {
        "category": "💝 Happy Valentine's Day",
        "folder": "d",
        "count": 1
    },
    {
        "category": "👩 Happy Mother's Day",
        "folder": "e",
        "count": 1
    },
    {
        "category": "👨 Happy Father's Day",
        "folder": "f",
        "count": 1
    },
    {
        "category": "🎄 Merry Christmas",
        "folder": "c",
        "count": 69
    },
    {
        "category": "🎊 Happy New Year",
        "folder": "l",
        "count": 1
    },
    {
        "category": "🥂 Happy Anniversary",
        "folder": "h",
        "count": 1
    },
    {
        "category": "🎉 Congratulations",
        "folder": "i",
        "count": 1
    },
    {
        "category": "🙏🏼 Get Well",
        "folder": "j",
        "count": 1
    },
    {
        "category": "🥰 Thinking of You",
        "folder": "k",
        "count": 1
    },
    {
        "category": "😭 I'm Sorry",
        "folder": "n",
        "count": 1
    },
    {
        "category": "🥺 Please Forgive Me",
        "folder": "o",
        "count": 1
    },
    {
        "category": "💌 Letter",
        "folder": "x",
        "count": 2
    },
    {
        "category": "📝 Note",
        "folder": "a",
        "count": 8
    },
    {
        "category": "❤️‍🩹 Help Wanted",
        "folder": "p",
        "count": 1
    },
    {
        "category": "💰 Tip Jar",
        "folder": "q",
        "count": 1
    },
    {
        "category": "💖 Donation Box",
        "folder": "r",
        "count": 1
    },
    {
        "category": "🧧 Treasure Chest",
        "folder": "s",
        "count": 1
    },
    {
        "category": "🏷️ Price Tag",
        "folder": "t",
        "count": 1
    },
    {
        "category": "💵 B-Dollar",
        "folder": "u",
        "count": 1
    },
    {
        "category": "💜 Purple Heart",
        "folder": "v",
        "count": 1
    },
    {
        "category": "🩵 Me",
        "folder": "w",
        "count": 1
    },
    {
        "category": "🔒 Secret",
        "folder": "y",
        "count": 1
    },
    {
        "category": "🔑 Password",
        "folder": "z",
        "count": 2
    }
]
